import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            内容分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-xl mx-auto">
            按不同分类浏览你感兴趣的黑料内容，从明星塌房到行业内幕，应有尽有
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-5 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}